module.exports = __webpack_public_path__ + "img/by.f4cbd761.svg";